import { NgModule } from '@angular/core';

import { MyobService }       from '../myob/myob.service';
import { SharedModule }      from '../shared/shared.module';
import { SyncMyobComponent } from './myob.sync.component';

@NgModule({
  declarations: [
    SyncMyobComponent
  ],
  entryComponents: [
    SyncMyobComponent
  ],
  exports: [
    SyncMyobComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    MyobService
  ]
})
export class MyobModule {}
